import { createContext, useContext } from 'react';

/*
 * «Технические детали» toggle of the journey section. Off by default: request
 * paths, build ids, response codes, selectors and `сервер` / `API` tags stay
 * hidden until an admin turns it on. The choice is remembered per browser.
 */

export const JOURNEY_TECH_MODE_STORAGE_KEY =
  'befront-admin-journey-tech-details';

type JourneyTechModeStorage = Pick<Storage, 'getItem' | 'setItem'>;

/** `localStorage` itself can throw (disabled storage, sandboxed iframe). */
const getDefaultStorage = (): JourneyTechModeStorage | null => {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
};

export const readJourneyTechMode = (
  storage: JourneyTechModeStorage | null = getDefaultStorage(),
): boolean => {
  try {
    return storage?.getItem(JOURNEY_TECH_MODE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const writeJourneyTechMode = (
  enabled: boolean,
  storage: JourneyTechModeStorage | null = getDefaultStorage(),
): void => {
  try {
    storage?.setItem(JOURNEY_TECH_MODE_STORAGE_KEY, String(enabled));
  } catch {
    // Private mode / full quota: the toggle still works for this page view.
  }
};

export type JourneyViewSettings = {
  techMode: boolean;
  /** Student of the page — goes into the «Скопировать для разработчика» text. */
  studentId: string | null;
};

/**
 * Provided by TimelineSection, so nested rows and cards read the toggle without
 * threading a prop through every list in between.
 */
export const JourneyViewContext = createContext<JourneyViewSettings>({
  techMode: false,
  studentId: null,
});

export const useJourneyTechMode = (): boolean =>
  useContext(JourneyViewContext).techMode;

export const useJourneyStudentId = (): string | null =>
  useContext(JourneyViewContext).studentId;
